import { Component, OnInit } from '@angular/core';
import { FormUserInstructorGroupComponent } from '../../../../@shared/components/forms/user-instructor-group/user-instructor-group.component';

@Component({
    selector: 'app-new',
    templateUrl: './new.component.html',
    styleUrls: ['./new.component.scss'],
    imports: [FormUserInstructorGroupComponent]
})
export class InstructorGroupNewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  onSubmit(event: any) {
    if (event.valid) {
      console.log('API CALL HERE--', event.values);
    }
  }
}
